module.exports = __webpack_public_path__ + "img/trebol.de0ffa53.png";